export default "__VITE_ASSET__C0x1N2S4__"